<template>
  <div>
    <!-- <div class="row">
      <div class="col">
        <div class="card shadow"> -->
    <div class="row no-gutters">
      <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
        <div class="card-body">
          <div class="filter-bar ui basic segment grid">
            <div class="row">
              <div class="col-md-12">
                <base-input label="Business Date"><br>
                  <a-date-picker v-model="filterText.business_date" format="MM/DD/YYYY"
                    placeholder="Business Date" style="width:100%" @change="doFilter" :allowClear=false />
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-input label="Site"><br>
                  <a-select v-model="filterText.site_id" showSearch placeholder="Search by site"
                    @change="filterTerminal" optionFilterProp="children" style="width: 100%"
                    :filterOption="filterOption">
                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">
                      {{ option.name }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-input label="Terminal"><br>
                  <a-select v-model="filterText.terminal_id" showSearch placeholder="Search by terminal"
                    @change="doFilter" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                    <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">
                      {{ option.name }}
                    </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-9">
        <div id="profileDiv" class="card-body">
          <profiles-table :filterText="filterText" :key="formKey"></profiles-table>
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
    </div>
  </div> -->
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import ProfilesTable from '../Tables/PdeViewingTable.vue'
import { mapState, mapActions } from 'vuex'
import moment from 'moment';

var component_x;

export default {
  data: function () {
    return {
      formKey: 0,
      activeModules: [],
      filterSettings: {},
      filterText: {
        terminal_id: 0,
        site_id: 0,
        business_date: moment().subtract(1, 'days'),
        trans_id: '',
        customer_name: '',
        filterStatus: '0',
        returnStatus: '0',
        reservationStatus: '0',
      },
      //   searchFilter: "terminal_id",
      filterStatus: '0',
      returnStatus: '0',
      reservationStatus: '0',
      dateFormat: "MM/DD/YYYY",
      terminalOptions: [],
      siteOptions: []
    }
  },
  mounted: async function () {
    component_x = this;

    // var siteId = secureStorage.getItem("defaultSiteId")
    // let userId = secureStorage.getItem("userId")

    var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=live", null, "BXI-File");
    component_x.siteOptions = sites;
    component_x.siteOptions.push({ id: 0, name: ' All Sites' })
    component_x.sort(component_x.siteOptions);
    component_x.filterText.site_id = 0

    let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=0", null);
    this.updateParameters("?business_date=" + this.filterText.business_date.format('YYYY-MM-DD'))

    component_x.terminalOptions = terminals;
    component_x.terminalOptions.push({ id: 0, name: ' All Terminals' })
    component_x.sort(component_x.terminalOptions);
  },
  computed: {
    ...mapState(['currentProfile', 'currentApiURL', 'endPoint']),
  },
  components: {
    ProfilesTable
  },
  watch: {
    filterStatus: async function () {
      Object.assign(this.filterText, {
        filterStatus: this.filterStatus
      })
      this.doFilter();
    },
    returnStatus: async function () {
      Object.assign(this.filterText, {
        returnStatus: this.returnStatus
      })
      this.doFilter();
    },
    reservationStatus: async function () {
      Object.assign(this.filterText, {
        reservationStatus: this.reservationStatus
      })
      this.doFilter();
    },
  },
  methods: {
    ...mapActions(['updateCurrentProfile', 'updateParameters']),
    moment,
    filterTerminal: async function () {
      component_x = this
      let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.filterText.site_id, null);
      component_x.terminalOptions = terminals;
      component_x.terminalOptions.push({ id: 0, name: ' All Terminals' })
      component_x.sort(component_x.terminalOptions);

      component_x.filterText.terminal_id = 0

      this.doFilter()
    },
    doFilter: async function () {
      let add_terminal = ""
      if (this.filterText.terminal_id != 0) {
        add_terminal = "&terminal_id=" + this.filterText.terminal_id
      }

      let add_site = ""
      if (this.filterText.site_id != 0) {
        add_site = "&site_id=" + this.filterText.site_id
      }

      this.updateParameters("?business_date=" + this.filterText.business_date.format('YYYY-MM-DD') + add_site + add_terminal)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    sort(data) {
      data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
  }
};
</script>

<style></style>
